import Select from '@acri-tools/react-tools/components/Select/Select';
import { nullUndefined } from '@acri-tools/react-tools/utils';
import React,{ Component } from 'react';
import { DCR_IMPLEMENTED_BY, DCR_STATUS } from '../../utils/data_maintenance';

import './DataMaintenanceForm.css';

interface Props{
    data_maintenance: any
    updates?: any
    onChange: (updates:any, data?:boolean)=>void
}
interface State{
}

export default class DataMaintenanceForm extends Component<Props,State>{
    constructor(props:Props){
        super(props);
    }


    get_value = (key:string, data?:boolean) =>{
        if(data){
            if(!nullUndefined(this.props.updates?.data?.[key])) return this.props.updates.data[key];
            return this.props.data_maintenance.data?.[key] || '';
        }
        if(!nullUndefined(this.props.updates?.[key])) return this.props.updates[key];
        return this.props.data_maintenance[key] || '';
    }

    
    render(){
        return (
            <div className="data-maintenance-form">
                <div className="form-field">
                    <label>Data maintenance governed by</label>
                    <Select
                        disabled={this.props.updates}
                        value={this.props.data_maintenance.type}
                        onChange={(type:string)=>{ this.props.onChange({ type }) }}
                        options={[
                            { label: 'Service request', value: 'service_request' },
                            { label: 'DCR', value: 'DCR' },
                        ]}
                    />
                </div>
                <br/>

                <div>
                    <div className="form-field">
                        <label><i className="fas fa-id-card"/> ID</label>
                        <input 
                            type="text" value={this.get_value('data_id')}
                            placeholder="ID" onChange={(e)=>{ this.props.onChange({ data_id: e.target.value }) }}
                        />
                    </div>
                </div>
                {
                    this.props.data_maintenance.type === 'service_request' ?
                        this.get_service_request_inputs()
                    :   this.get_DCR_inputs()
                }

            </div>
        );
    }
    
    get_service_request_inputs = () =>(
        <>
            <div className="row-2">
                <div>
                    <div className="form-field">
                        <label><i className="fas fa-satellite"/> Original Dataset</label>
                        <input 
                            type="text" value={this.get_value('original_dataset', true)}
                            placeholder="Original Dataset" onChange={(e)=>{ this.props.onChange({ original_dataset: e.target.value }, true) }}
                        />
                    </div>
                </div>
                <div>
                    <div className="form-field">
                        <label><i className="fas fa-satellite"/> Final Dataset</label>
                        <input 
                            type="text" value={this.get_value('final_dataset', true)}
                            placeholder="Final Dataset" onChange={(e)=>{ this.props.onChange({ final_dataset: e.target.value }, true) }}
                        />
                    </div>
                </div>
            </div>
            <div className="form-field">
                <label><i className="fas fa-font"/> Change applied</label>
                <textarea
                    value={this.get_value('change_applied', true)}
                    placeholder="Change applied" 
                    onChange={(e)=>{ this.props.onChange({ change_applied: e.target.value }, true) }}
                />
            </div>
        </>
    )

    get_DCR_inputs = () =>(
        <>
            <div className="row-2">
                <div>
                    <div className="form-field">
                        <label><i className="fas fa-satellite"/> Mission</label>
                        <input 
                            type="text" value={this.get_value('mission', true)}
                            placeholder="Mission" onChange={(e)=>{ this.props.onChange({ mission: e.target.value }, true) }}
                        />
                    </div>
                    <div className="form-field">
                        <label><i className="fas fa-asterisk"/> Status</label>
                        <Select
                            value={this.get_value('status', true)}
                            nullable
                            onChange={(status:string)=>{ this.props.onChange({ status }, true) }}
                            options={DCR_STATUS.map((v:any)=>{
                                return { label:v, value:v }
                            })}
                        />
                    </div>
                    <div className="form-field">
                        <label><i className="fas fa-calendar"/> Date of request</label>
                        <input 
                            type="date" value={this.get_value('request_date', true) }
                            placeholder="Date of request" onChange={(e)=>{ this.props.onChange({ request_date: e.target.value }, true) }}
                        />
                    </div>
                </div>
                <div>
                    <div className="form-field">
                        <label><i className="fas fa-heading"/> DCR Title</label>
                        <input 
                            type="text" value={this.get_value('title', true)}
                            placeholder="Title" onChange={(e)=>{ this.props.onChange({ title: e.target.value }, true) }}
                        />
                    </div>
                    <div className="form-field">
                        <label><i className="fas fa-folder"/> Repository of output data</label>
                        <input
                            type="text" value={this.get_value('repository_of_output_data', true)}
                            placeholder="Repository of output data" 
                            onChange={(e)=>{ this.props.onChange({ repository_of_output_data: e.target.value }, true) }}
                        />
                    </div>
                    <div className="form-field">
                        <label><i className="fas fa-calendar-alt"/> Date of closure</label>
                        <input
                            type="date" value={this.get_value('date_of_closure', true)}
                            placeholder="Date of validation" onChange={(e)=>{ this.props.onChange({ date_of_closure: e.target.value }, true) }}
                        />
                    </div>
                </div>
            </div>
            <div className="row-2">
                <div className="form-field">
                    <label><i className="fas fa-file"/> Description</label>
                    <input
                        type="file" placeholder="Description" 
                        onChange={(e)=>{
                            if(e.target.files){                            
                                this.props.onChange({ description: e.target.files[0] }, true);
                            }
                        }}
                    />
                </div>
                <div className="form-field">
                    <label><i className="fas fa-asterisk"/> Implemented by</label>
                    <Select
                        value={this.get_value('implemented_by', true)}
                        nullable
                        onChange={(implemented_by:string)=>{ this.props.onChange({ implemented_by }, true) }}
                        options={DCR_IMPLEMENTED_BY.map((v:any)=>{
                            return { label:v, value:v }
                        })}
                    />
                </div>
            </div>

        </>
    )
};